<template>
  <div class="message-manage-page">
    <!-- <div class="title">消息通知</div> -->
    <div class="tabs">
      <a-tabs :activeKey="activeKey" @change="changeTab">
        <a-tab-pane key="1">
          <template slot="tab">
            <a-badge style="width: 70px" :count="messageTotal.tenantTotal || 0">
              <div class="tab-title">租户状态</div>
            </a-badge>
          </template>
          <!-- <MessageContent
            :messageList="tenantArr"
            :pagination="tenantPagi"
            :messageNum="messageTotal.tenantTotal || 0"
            @changePagi="changePagi"
            @onChangeMessage="onChangeMessage"
            @onDeletePagemsg="onDeletePagemsg"
          /> -->
        </a-tab-pane>
        <a-tab-pane key="2">
          <template slot="tab">
            <a-badge
              style="width: 70px"
              :count="messageTotal.contractTotal || 0"
            >
              <div class="tab-title">合同状态</div>
            </a-badge>
          </template>
          <!-- <MessageContent
            :messageList="contractArr"
            :pagination="contractPagi"
            :messageNum="messageTotal.contractTotal || 0"
            @changePagi="changePagi"
            @onChangeMessage="onChangeMessage"
            @onDeletePagemsg="onDeletePagemsg"
          /> -->
        </a-tab-pane>
        <a-tab-pane key="3">
          <template slot="tab">
            <a-badge style="width: 70px" :count="messageTotal.deviceTotal || 0">
              <div class="tab-title">设备操作</div>
            </a-badge>
          </template>
          <!-- <MessageContent
            :messageList="deviceArr"
            :pagination="devicePagi"
            :messageNum="messageTotal.deviceTotal || 0"
            @changePagi="changePagi"
            @onChangeMessage="onChangeMessage"
            @onDeletePagemsg="onDeletePagemsg"
          /> -->
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="content" id="table">
      <div v-if="activeKey === '1'">
        <MessageContent
          :messageList="tenantArr"
          :pagination="tenantPagi"
          :messageNum="messageTotal.tenantTotal || 0"
          @changePagi="changePagi"
          @onChangeMessage="onChangeMessage"
          @onDeletePagemsg="onDeletePagemsg"
        />
      </div>
      <div v-if="activeKey === '2'">
        <MessageContent
          :messageList="contractArr"
          :pagination="contractPagi"
          :messageNum="messageTotal.contractTotal || 0"
          @changePagi="changePagi"
          @onChangeMessage="onChangeMessage"
          @onDeletePagemsg="onDeletePagemsg"
        />
      </div>
      <div v-if="activeKey === '3'">
        <MessageContent
          :messageList="deviceArr"
          :pagination="devicePagi"
          :messageNum="messageTotal.deviceTotal || 0"
          @changePagi="changePagi"
          @onChangeMessage="onChangeMessage"
          @onDeletePagemsg="onDeletePagemsg"
        />
      </div>
    </div>
  </div>
</template>
<script>
import eventStatusMixin from "../../../mixins/eventStatus";
import MessageContent from "./component/messagecontent.vue";
import { mapState, mapActions } from "vuex";
import scrollbarInit from "../../../utils/perfectScrollBar";
import {
  informationDelete,
  informationPage,
  informationUnreadTotal,
  informationUpdate,
} from "./service";
export default {
  mixins: [eventStatusMixin],
  components: { MessageContent },
  data() {
    return {
      activeKey: "1",
      dataSource: [],
      tenantPagi: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      contractPagi: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      devicePagi: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    tenantArr: function () {
      let key = this.activeKey;
      if (key === "1") {
        return this.dataSource;
      } else return [];
    },
    contractArr: function () {
      let key = this.activeKey;
      if (key === "2") {
        return this.dataSource;
      } else return [];
    },
    deviceArr: function () {
      let key = this.activeKey;
      if (key === "3") {
        return this.dataSource;
      } else return [];
    },
    ...mapState({
      messageTotal: (state) => state.information.messageObj,
    }),
  },
  created() {
    this.getMessageTotalData();
    this.getMessageData();
  },
  mounted() {
    this.createScroll();
  },
  methods: {
    createScroll() {
      const scrollBar = scrollbarInit("#table");
      const dom = document.querySelector("#table");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    ...mapActions({ getMessageTotalData: "information/FETCH_MESSAGEDATA" }),
    changeTab(key) {
      this.activeKey = key;
      this.setState();
      this.getMessageData();
    },
    setState() {
      this.dataSource = [];
      this.tenantPagi = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.contractPagi = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.devicePagi = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
    },
    changePagi(page) {
      console.log(page);
      this.getMessageData(page);
    },
    async getInfomationTotalData() {
      try {
        const params = {};

        const res = await informationUnreadTotal.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          console.log(res);
        }
      } catch (err) {
        console.error;
      }
    },
    async getMessageData(pageNo = 0) {
      try {
        const params = {
          pageNo,
          pageSize: 10,
        };

        if (this.activeKey === "1") {
          params.informationType = "TENANT";
        } else if (this.activeKey === "3") {
          params.informationType = "DEVICE";
        } else {
          params.informationType = "CONTRACT";
        }

        const res = await informationPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          if (this.activeKey === "1") {
            this.tenantPagi = {
              current: res.data.pageNo + 1,
              pageSize: 10,
              total: res.data.totalCount,
            };
          } else if (this.activeKey === "2") {
            this.contractPagi = {
              current: res.data.pageNo + 1,
              pageSize: 10,
              total: res.data.totalCount,
            };
          } else {
            this.devicePagi = {
              current: res.data.pageNo + 1,
              pageSize: 10,
              total: res.data.totalCount,
            };
          }
        }
        console.log(this.tenantPagi);
        this.dataSource = res.data.items;
      } catch (err) {
        console.error(err);
      }
    },
    async onChangeMessage(params = {}) {
      if (this.hasEventState("onChangeMessage")) return;
      try {
        this.addEventState("onChangeMessage");

        const res = await informationUpdate.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("已读成功");
          this.getMessageTotalData();
          let page = 0;
          if (this.activeKey === "1") {
            page = this.tenantPagi.current - 1;
          } else if (this.activeKey === "2") {
            page = this.contractPagi.current - 1;
          } else {
            page = this.devicePagi.current - 1;
          }
          this.getMessageData(page);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onChangeMessage");
      }
    },
    async onDeletePagemsg(params = {}) {
      if (this.hasEventState("onDeletePagemsg")) return;
      try {
        this.addEventState("onDeletePagemsg");

        const res = await informationDelete.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("删除已读消息成功");
          let page = 0;
          if (this.activeKey === "1") {
            page = this.tenantPagi.current - 1;
          } else if (this.activeKey === "2") {
            page = this.contractPagi.current - 1;
          } else {
            page = this.devicePagi.current - 1;
          }
          this.getMessageData(page);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onDeletePagemsg");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]

.message-manage-page {
  width: 100%;
  overflow: hidden;
  > ::v-deep .tabs {
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    padding-left: .convertPxToDesighVW(24) [];
    height: .convertPxToDesighVH(70) [];
    > .ant-tabs {
      > .ant-tabs-bar {
        > .ant-tabs-nav-container {
          > .ant-tabs-nav-wrap {
            height: .convertPxToDesighVH(48) [];
            border-radius: .convertPxToDesighVH(5) [];
            > .ant-tabs-nav-scroll {
              > .ant-tabs-nav {
                > div {
                  > .ant-tabs-tab-active {
                    color: #22dd90 !important;
                  }
                  > .ant-tabs-tab {
                    color: #909ca6;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  > .content {
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    margin-top: .convertPxToDesighVH(24) [];
    padding: .convertPxToDesighVH(24) [];
    height: calc(100vh - .convertPxToDesighVH(215) []);
    overflow: auto;
  }
}
</style>
